import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListSubheader from "@mui/material/ListSubheader";

import Collapse from "@mui/material/Collapse";
import Logo from "../../media/logonobg.png";
import React, { useContext, useState, useEffect } from "react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Context } from "../../Helper/Context";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import etoille from "../../media/start.jpeg"
import Noetoille from "../../media/startred.png"
import h from "../../media/h.png"
import bookmark from "../../media/fav.jpeg"
import amis from "../../media/amis.png"
import message from "../../media/message.png"
import Chroniques from "../../media/ICONS THEMATIQUE/Fichier 5_1.png"
import Societe from "../../media/ICONS THEMATIQUE/Fichier2.png"
import culture from "../../media/ICONS THEMATIQUE/Fichier 3.png"
import poignee from "../../media/ICONS THEMATIQUE/Fichier 4.png"
import ajouterth from "../../media/ICONS THEMATIQUE/ajouter une thématique_1.png"
import info from "../../media/ICONS THEMATIQUE/info.png"
import info2 from "../../media/ICONS THEMATIQUE/info_2.png"
import Planete from "../../media/ICONS THEMATIQUE/monde.png"
import heart from "../../media/heart.png";
// import { useLocation } from 'react-router-dom';
import userApi, { getCountUserNotifications } from "../../HTTP/user"
import "./side.css";
import * as helpers from "../../Helper/utils"; // Importez tout le module helper
import { countries } from "../../global/countriesAndSources";
import { fetchThematicsTree, fetchCountryInfo, toggleUserThematic } from "../../HTTP/thematics";
import { HeartBroken } from "@mui/icons-material";

const zemuservicesIcon = h
const zemusearchIcon = bookmark
const zemusIaIcon = ajouterth
const mesPublicationsIcon = Noetoille
const forumsIcon = `${process.env.PUBLIC_URL}/sidebar/people.png`

const user = JSON.parse(localStorage.getItem("user"))

const Side = (props) => {
  let country = JSON.parse(sessionStorage.getItem("search_country_country"))
  if (country === null) {
    country = JSON.parse(sessionStorage.getItem("search_country"))
    if (country === null) {
      country = countries.find((c) => c.code === user.country)
    }
  }
  const lowerSection = props.sideBarLowerSection
  const { friendAction } = useContext(Context);

  const [open, setOpen] = useState(false);
  const [openTools, setOpenTools] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  // const location = useLocation();

  const [friends, setFriends] = useState([]);
  const [countNotifications, setCountNotifications] = useState(0)
  //const [inviteAction, toggleInviteAction] = useState(false);

  useEffect(() => {
    const funCountNotifications = async () => {
      const resCountNotifications = await getCountUserNotifications(user.id)
      setCountNotifications(resCountNotifications)
    }
    funCountNotifications()
  }, [])

  useEffect(() => {
    // if (location.pathname === "/friends") {
    //   // userApi.getAllFriends().then((f) => setFriends(f))
    // }
  }, [friendAction])


  const handleClick = () => {
    setOpen(!open);
  };


  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    userApi.searchFriends(searchTerm).then((f) => setFriends(f))
  }


  const [tree, setTree] = useState([])
  const [favorites, setFavorites] = useState([])
  const [thematicsReady, setThematicsReady] = useState(false)
  const [changeThematics, setChangeThematics] = useState(0)
  const [openNodes, setOpenNodes] = useState({})

  const selectedThematic = new URL(window.location.href).searchParams.get("thematic") || sessionStorage.getItem("thematic")

  // Chemin d'ids de la racine jusqu'au nœud (null si absent)
  const findPath = (nodes, id, path = []) => {
    for (const n of nodes) {
      if (String(n.id) === String(id)) return [...path, n]
      const found = findPath(n.children || [], id, [...path, n])
      if (found) return found
    }
    return null
  }

  useEffect(() => {
    let cancelled = false
    const funGetThematics = async () => {
      const res = await fetchThematicsTree(country.code && country.code !== "wd" ? country.code : undefined)
      if (cancelled) return
      const nodes = res.tree || []
      setTree(nodes)
      setFavorites(res.favorites || [])
      if (selectedThematic) {
        const path = findPath(nodes, selectedThematic)
        if (path) {
          const selected = path[path.length - 1]
          sessionStorage.setItem("thematic_name", selected.name)
          sessionStorage.setItem("thematic_path", JSON.stringify(path.map((n) => n.name)))
          setOpenNodes((prev) => {
            const next = { ...prev }
            path.slice(0, -1).forEach((n) => { next[n.id] = true })
            return next
          })
        }
      }
      setThematicsReady(true)
    }
    funGetThematics()
    return () => { cancelled = true }
  }, [changeThematics])

  const handleToggleThematic = async (thematicId) => {
    try {
      await toggleUserThematic(user.id, thematicId)
      setChangeThematics((c) => c + 1)
    } catch (error) {
      alert('An error occured while updating thematic')
    }
  }

  const toggleNode = (key) => {
    setOpenNodes((prev) => ({ ...prev, [key]: !prev[key] }))
  }

  const handleThematic = (node) => {
    sessionStorage.setItem("thematic", node.id)
    sessionStorage.setItem("thematic_name", node.name)
    const nodePath = findPath(tree, node.id)
    sessionStorage.setItem("thematic_path", JSON.stringify(nodePath ? nodePath.map((n) => n.name) : [node.name]))
    // Si on est sur zemus-ia, rester sur cette page avec la nouvelle thématique
    if (isActivePath("/zemus-ia")) {
      window.location.href = `/zemus-ia?thematic=${node.id}`
    } else if (isActivePath("/search")) {
      window.location.href = `/search?thematic=${node.id}`
    } else {
      window.location.href = `/${country.code ? country.code : user.country}/what-this-country-talk-about?thematic=${node.id}`
    }
  }

  const thematicLabel = sessionStorage.getItem("thematic_name") || sessionStorage.getItem("thematic")

  const renderNode = (node, depth, keyPrefix = "") => {
    const hasChildren = node.has_children || (node.children && node.children.length > 0)
    const isOpen = !!openNodes[node.id]
    const isSelected = String(node.id) === String(selectedThematic)
    const isDeep = depth >= 3
    return (
      <div key={`${keyPrefix}${node.id}`}>
        <ListItemButton
          sx={{ marginBottom: depth === 0 ? "8px" : undefined, marginTop: depth === 0 ? undefined : "-12px", paddingLeft: `${16 + depth * 14}px` }}
          style={{ backgroundColor: isSelected ? '#c3e5ef' : "transparent" }}
        >
          {depth === 0 ? (
            <img className="imgicon" src={culture} alt="Icon" />
          ) : (
            <img
              className="imgicon"
              src={node.is_favorite ? etoille : Noetoille}
              alt="Icon"
              onClick={() => handleToggleThematic(node.id)}
            />
          )}
          <span
            className={depth === 0 ? "spanacc" : node.count_links > 0 ? "boldff" : "ff"}
            style={isDeep ? { color: "#888" } : undefined}
            onClick={() => handleThematic(node)}
          >
            {node.name}
          </span>
          {hasChildren && (
            <span style={{ marginLeft: "auto", display: "flex" }} onClick={() => toggleNode(node.id)}>
              {isOpen ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
            </span>
          )}
        </ListItemButton>
        {hasChildren && (
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {(node.children || []).map((child) => renderNode(child, depth + 1, keyPrefix))}
            </List>
          </Collapse>
        )}
      </div>
    )
  }

  const [countryInfo, setCountryInfo] = useState(undefined)
  const [countryInfoReady, setCountryInfoReady] = useState(false)
  useEffect(() => {
    const funGetInfo = async () => {
      const resInfo = await fetchCountryInfo(country.code)
      setCountryInfo(resInfo)
      setCountryInfoReady(true)
    }
    funGetInfo()
  }, [country.code])

  const url = new URL(window.location.href)

  const isUserSubscribed = JSON.parse(localStorage.getItem("subscriptions")) !== null
  const currentPath = window.location.pathname
  const isActivePath = (path) => currentPath === path || currentPath.startsWith(`${path}/`)
  const showToolsSubmenu =
    lowerSection === "thematics" && (isActivePath("/search") || isActivePath("/zemus-ia"))

  return (
    <List
      sx={{ bgcolor: "#f6f4f5", width: "250px", maxHeight: "100vh", overflow: "auto", '@media (max-width: 767px)': { maxHeight: "calc(100vh - 50px)" } }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader component="div" id="nested-list-subheader" onClick={() => {
          const homeCountry = countries.find((co) => co.code === JSON.parse(localStorage.getItem("user")).country)
          if (homeCountry.code !== JSON.parse(sessionStorage.getItem("search_country")).code) {
            sessionStorage.removeItem('search_themes_country')
            sessionStorage.removeItem('search_country_country')
            sessionStorage.setItem("search_country", JSON.stringify(homeCountry))
          }
          sessionStorage.setItem("search_query", "")
          sessionStorage.setItem("search_igo", "")
          sessionStorage.removeItem('thematic')
          window.location.href = "/"
        }}>
          <img
            src={Logo}
            className="logo"
            style={{ width: "220px", marginTop: "0", maxWidth: "80%", marginBottom: "15px", paddingTop: "10px" }}
            alt="Logo"
          />
        </ListSubheader>
      }
    >
      {
        (country.code !== "wd" || sessionStorage.getItem("thematic")) && (
          <>
            <div className="search_bar">
              <div className="search_bar_left">
                <SearchIcon />
              </div>
              <div className="search_bar_right">
                {
                  (
                    <h3>
                      <span className="text-zemusbis font-bold">Pays :</span> {country.code === "wd" && sessionStorage.getItem("search_igo") ? '(Forum)' : ''} {country.code === "wd" ? "Tous les pays" : country.name}
                    </h3>
                  )
                }
                {
                  sessionStorage.getItem("thematic") && (
                    <h3>
                      <span className="text-zemusbis font-bold">Source :</span> {thematicLabel}
                    </h3>
                  )
                }
              </div>

            </div></>
        )}
      <ListItemButton className="sideMenuButton" selected={isActivePath("/feed")} onClick={() => window.location.href = "/feed"} >
        <img className="imgicon" src={info2} alt="Icon" />
        <span className="spanacc">Fil d’actualité</span>
      </ListItemButton>

      {showToolsSubmenu ? (
        <>
          <ListItemButton className="sideMenuButton" onClick={() => setOpenTools((previous) => !previous)}>
            <img className="imgicon" src={zemuservicesIcon} alt="Icon" />
            <span className="spanacc notranslate" translate="no">ZemuServices</span>
            {openTools ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
          </ListItemButton>
          <Collapse in={openTools} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} selected={isActivePath("/search")} onClick={() => window.location.href = "/search"}>
                <img className="imgicon" src={zemusearchIcon} alt="Icon" />
                <span className="spanacc notranslate" translate="no">ZemuSearch</span>
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} selected={isActivePath("/zemus-ia")} onClick={() => window.location.href = "/zemus-ia"}>
                <img className="imgicon" src={zemusIaIcon} alt="Icon" />
                <span className="spanacc">Zemus IA</span>
              </ListItemButton>
              {isUserSubscribed && (
                <>
                  <ListItemButton sx={{ pl: 4 }} selected={isActivePath("/igo")} onClick={() => window.location.href = "/igo"}>
                    <img className="imgiconMessage" src={forumsIcon} alt="Icon" />
                    <span className="spanacc">Forums Globaux</span>
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} selected={isActivePath("/followed")} onClick={() => window.location.href = "/followed"}>
                    <img className="imgicon" src={Planete} alt="Icon" />
                    <span className="spanacc">Mes Recherches</span>
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} selected={isActivePath("/favourites")} onClick={() => window.location.href = "/favourites"}>
                    <img className="imgicon" src={heart} alt="Icon" />
                    <span className="spanacc">Partager mes favoris</span>
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} selected={isActivePath("/myarticles")} onClick={() => window.location.href = "/myarticles"}>
                    <img className="imgiconfav" src={Chroniques} alt="Icon" />
                    <span className="spanacc">Publier mes articles</span>
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} selected={isActivePath("/mypublications")} onClick={() => window.location.href = "/mypublications"}>
                    <img className="imgicon" src={etoille} alt="Icon" />
                    <span className="spanacc">Mes Publications</span>
                  </ListItemButton>
                </>
              )}
              <ListItemButton sx={{ pl: 4 }} selected={isActivePath("/friends")} onClick={() => window.location.href = "/friends"}>
                <img className="imgicon" src={poignee} alt="Icon" />
                <span className="spanacc">Amis</span>
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} selected={isActivePath("/notifications")} onClick={() => window.location.href = "/notifications"}>
                <img className="imgiconMessage" src={message} alt="Icon" />
                <span className="spanacc">Notifications {countNotifications !== 0 ? "(" + countNotifications + ")" : ""}</span>
              </ListItemButton>
            </List>
          </Collapse>
        </>
      ) : (
        <>
          <ListItemButton className="sideMenuButton" selected={isActivePath("/search")} onClick={() => window.location.href = "/search"} >
            <img className="imgicon" src={zemusearchIcon} alt="Icon" />
            <span className="spanacc notranslate" translate="no">ZemuSearch</span>
          </ListItemButton>

          <ListItemButton className="sideMenuButton" selected={isActivePath("/zemus-ia")} onClick={() => window.location.href = "/zemus-ia"} >
            <img className="imgicon" src={zemusIaIcon} alt="Icon" />
            <span className="spanacc">Zemus IA</span>
          </ListItemButton>

          {isUserSubscribed && (
            <>
              <ListItemButton className="sideMenuButton" selected={isActivePath("/igo")} onClick={() => window.location.href = "/igo"}>
                <img className="imgiconMessage" src={forumsIcon} alt="Icon" />
                <span className="spanacc">Forums Globaux</span>
              </ListItemButton>
              <ListItemButton className="sideMenuButton" selected={isActivePath("/followed")} onClick={() => window.location.href = "/followed"}>
                <img className="imgicon" src={Planete} alt="Icon" />
                <span className="spanacc">Mes Recherches</span>
              </ListItemButton>
              <ListItemButton className="sideMenuButton" selected={isActivePath("/favourites")} onClick={() => window.location.href = "/favourites"}>
                <img className="imgicon" src={heart} alt="Icon" />
                <span className="spanacc">Partager mes favoris</span>
              </ListItemButton>
              <ListItemButton className="sideMenuButton" selected={isActivePath("/myarticles")} onClick={() => window.location.href = "/myarticles"}>
                <img className="imgiconfav" src={Chroniques} alt="Icon" />
                <span className="spanacc">Publier mes articles</span>
              </ListItemButton>
              <ListItemButton className="sideMenuButton" selected={isActivePath("/mypublications")} onClick={() => window.location.href = "/mypublications"}>
                <img className="imgicon" src={etoille} alt="Icon" />
                <span className="spanacc">Mes Publications</span>
              </ListItemButton>
            </>
          )}

          <ListItemButton className="sideMenuButton" selected={isActivePath("/friends")} onClick={() => window.location.href = "/friends"}>
            <img className="imgicon" src={poignee} alt="Icon" />
            <span className="spanacc">Amis</span>
          </ListItemButton>

          <ListItemButton className="sideMenuButton" selected={isActivePath("/notifications")} onClick={() => window.location.href = "/notifications"}>
            <img className="imgiconMessage" src={message} alt="Icon" />
            <span className="spanacc">Notifications {countNotifications !== 0 ? "(" + countNotifications + ")" : ""}</span>
          </ListItemButton>
        </>
      )}

      <ListItemButton className="sideMenuButton" selected={isActivePath("/profile")} onClick={() => window.location.href = "/profile"}>
        <img className="iconProfil" src={user.profile_picture || process.env.PUBLIC_URL + "/profile_pic_default_3.jpg"} alt="Profile pic" />
        <span className="spanacc">Profil</span>
      </ListItemButton>


      {
        lowerSection === "thematics" && (
          <>
            {" "}
            {
              isUserSubscribed && thematicsReady && (
                <>
                  <ListItemButton sx={{ marginBottom: "-8px" }}>
                    <span className="title">Sources</span>
                  </ListItemButton>

                  {favorites.length > 0 && (
                    <div>
                      <ListItemButton sx={{ marginBottom: "8px" }} onClick={() => toggleNode("favorites")}>
                        <img className="imgicon" src={etoille} alt="Icon" />
                        <span className="spanacc">Préférences</span>
                        {openNodes["favorites"] ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
                      </ListItemButton>
                      <Collapse in={!!openNodes["favorites"]} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                          {favorites.map((fav) => renderNode({ ...fav, children: [], has_children: false }, 1, "fav-"))}
                        </List>
                      </Collapse>
                    </div>
                  )}

                  {tree.map((node) => renderNode(node, 0))}
                </>
              )
            }
            {/* <ListItemButton sx={{  marginBottom: "8px" }}>
              <img className="imgicon" src={Chroniques} alt="Icon" />
              <span className="spanacc">Chroniques</span>
            </ListItemButton>
            <ListItemButton sx={{  marginTop: "-12px" }}>
              <img className="imgicon" src={Noetoille} alt="Icon" /> <span className="ff">
                {" "}
                Politique
                Choix Élections
              </span>
            </ListItemButton>
            <ListItemButton sx={{  marginTop: "-12px" }}>
              <img className="imgicon" src={Noetoille} alt="Icon" /> <span className="ff">
                {" "}
                Économie
                Finance
              </span>
            </ListItemButton>
            <ListItemButton sx={{  marginTop: "-12px" }}>
              <img className="imgicon" src={Noetoille} alt="Icon" /> <span className="ff">
                {" "}
                Contrats
                Investissements
              </span>
            </ListItemButton>
            <ListItemButton sx={{  marginTop: "-12px" }}>
              <img className="imgicon" src={Noetoille} alt="Icon" /> <span className="ff">
                {" "}
                Affaires
                étrangères
              </span>
            </ListItemButton>
            <ListItemButton sx={{  marginTop: "-12px" }}>
              <img className="imgicon" src={Noetoille} alt="Icon" /> <span className="ff">
                {" "}
                Fête
                Commémoration
              </span>
            </ListItemButton>
            <ListItemButton sx={{  marginTop: "-12px" }}>
              <img className="imgicon" src={Noetoille} alt="Icon"  /> <span className="ff">
                {" "}
                Théâtre
                Concert Exposition
              </span>
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                try {
                  SetFil("Société");
                } catch (error) {
                  window.location.replace("/");
                }
              }}

            >
              <img className="imgicon" src={Societe} alt="Icon" />
              <span className="spanacc">Société</span>
            </ListItemButton>

            <ListItemButton>
              <img className="imgicon" src={culture} alt="Icon" />
              <span className="spanacc">Culture</span>
            </ListItemButton>

            <ListItemButton>
              <img className="imgicon" src={vivre} alt="Icon" />
              <span className="spanacc">Vivre ensemble</span>
            </ListItemButton>

            <ListItemButton>
              <img className="imgicon" src={Planete} alt="Icon" />
              <span className="spanacc">Planète</span>
            </ListItemButton>
            <ListItemButton>
              <img className="imgicon" src={ajouterth} alt="Icon" />
              <span className="spanacc">Ajouter un thématique</span>
            </ListItemButton> */}

            {
              countryInfoReady && countryInfo !== undefined && (
                <>
                  <ListItemButton onClick={handleClick}>
                    <img className="imgicon" src={info} alt="Icon" />
                    <span className="spanacc">Informations</span>
                    {open ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
                  </ListItemButton>

                  <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{ pl: 4, marginTop: "-12px" }}
                      >
                        <span className="ff">
                          Nom : <span className="spblack">{countryInfo.name}</span>{" "}
                        </span>
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4, marginTop: "-12px" }}
                      >
                        <span className="ff">
                          Capital : <span className="spblack">{countryInfo.capital}</span>{" "}
                        </span>
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4, marginTop: "-12px" }}
                      >
                        <span className="ff">
                          Population : <span className="spblack">{countryInfo.population}</span>
                        </span>
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4, marginTop: "-12px" }}
                      >
                        <span className="ff">
                          Gentilé: <span className="spblack">{countryInfo.demonym}</span>
                        </span>
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4, marginTop: "-12px" }}
                      >
                        <span className="ff">
                          Devise : <span className="spblack">{countryInfo.currencies}</span>
                        </span>
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4, marginTop: "-12px" }}
                      >
                        <span className="ff">
                          Langue :<span className="spblack"> {countryInfo.languages}</span>
                        </span>
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4, marginTop: "-12px" }}
                      >
                        <span className="ff">
                          Région : <span className="spblack">{countryInfo.region}</span>{" "}
                        </span>
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4, marginTop: "-12px" }}
                      >
                        <span className="ff">
                          Sous-région :{" "}
                          <span className="spblack">{countryInfo.subregion}</span>
                        </span>
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4, marginTop: "-12px" }}
                      >
                        <span className="ff">
                          Téléphone : <span className="spblack"> {countryInfo.phone}</span>
                        </span>
                      </ListItemButton>
                    </List>
                  </Collapse>
                </>
              )
            }
            {" "}
          </>
        )
      }

      {
        lowerSection === "friends_requests" && (
          <>
            <div className="friends_request_search">
              <Paper
                component="form"
                id="search_bar"
                onSubmit={handleSubmit}
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: "313px",
                  marginTop: "20px",
                  borderRadius: "67px",
                  border: "1px solid #00D5F3",
                  marginLeft: "21px",
                  height: "40px",
                  marginRight: "9px"
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Recherche amis ..."
                  inputProps={{ "aria-label": "Rechercher" }}
                  value={searchTerm}
                  onChange={handleInputChange}
                />
                <IconButton type="submit" sx={{ p: "10px" }} aria-label="search">
                  <SearchIcon />
                </IconButton>
              </Paper>

            </div>

            <div className="listamisdiv">
              <ul id="friend-list">
                {
                  friends.map((f) =>
                    <li className="friendsent" key={Math.random() * 69}>
                      <img src={f.profile_picture || process.env.PUBLIC_URL + "/profile_pic_default_2.svg"} alt="Profile pic" />
                      <div className="name">
                        <p>{helpers.truncateString(f.firstname, 10)} {helpers.truncateString(f.lastname, 10)}</p>
                      </div>
                    </li>
                  )
                }
              </ul>
            </div>

          </>
        )
      }

    </List>
  );
};

export default Side;
